export const PLACEMENT = {
  aboveLeft: 'above-left',
  above: 'above',
  aboveRight: 'above-right',
  highRight: 'high-right',
  right: 'right',
  lowRight: 'low-right',
  belowRight: 'below-right',
  below: 'below',
  belowLeft: 'below-left',
  lowLeft: 'low-left',
  left: 'left',
  highLeft: 'high-left',
  none: 'none'
};
export const ABOVE_POSITIONS = [PLACEMENT.aboveLeft, PLACEMENT.above, PLACEMENT.aboveRight];
export const BELOW_POSITIONS = [PLACEMENT.belowLeft, PLACEMENT.below, PLACEMENT.belowRight];
export const SIDE_POSITIONS = [PLACEMENT.highLeft, PLACEMENT.left, PLACEMENT.lowLeft, PLACEMENT.highRight, PLACEMENT.right, PLACEMENT.lowRight];
export const LEFT_POSITIONS = [PLACEMENT.highLeft, PLACEMENT.left, PLACEMENT.lowLeft];
export const RIGHT_POSITIONS = [PLACEMENT.highRight, PLACEMENT.right, PLACEMENT.lowRight];
export const QUADS = [{
  index: 0,
  bestAltIndex: 2,
  worstAltIndex: 1,
  placements: [PLACEMENT.above, PLACEMENT.aboveLeft, PLACEMENT.aboveRight],
  visited: false
}, {
  index: 1,
  bestAltIndex: 3,
  worstAltIndex: 0,
  placements: [PLACEMENT.right, PLACEMENT.highRight, PLACEMENT.lowRight],
  visited: false
}, {
  index: 2,
  bestAltIndex: 0,
  worstAltIndex: 3,
  placements: [PLACEMENT.below, PLACEMENT.belowLeft, PLACEMENT.belowRight],
  visited: false
}, {
  index: 3,
  bestAltIndex: 1,
  worstAltIndex: 0,
  placements: [PLACEMENT.left, PLACEMENT.highLeft, PLACEMENT.lowLeft],
  visited: false
}];